import { createElementBlock as o, createCommentVNode as r, openBlock as s, normalizeClass as a, toDisplayString as m } from "vue";
import { themeProp as n } from "../../composables/useTheme.js";
/* empty css             */
import c from "../../_virtual/_plugin-vue_export-helper.js";
const p = "DsEyebrow", d = /* @__PURE__ */ Object.assign({
  name: p
}, {
  __name: "eyebrow",
  props: {
    ...n,
    text: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (t, i) => e.text ? (s(), o("p", {
      key: 0,
      class: a([`ds-eyebrow--${t.theme}`, "ds-eyebrow ds-text-mono ds-text-transform-uppercase"]),
      "data-j-eyebrow": ""
    }, m(e.text), 3)) : r("", !0);
  }
}), f = /* @__PURE__ */ c(d, [["__scopeId", "data-v-8add570d"]]);
export {
  f as default
};
